import React, { useEffect, useState } from "react";
import { CiLocationOn } from "react-icons/ci";
import { NavLink } from "react-router-dom";
import { server } from "../../../common";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../../store/stateFunctions";
import { toast } from "react-toastify";
import { FaLocationDot } from "react-icons/fa6";

const Bookmark = () => {
  const user = useSelectAccess("Student");
  const [indjobs, setIndjobs] = useState([]);
  const [indinternships, setIndinternships] = useState([]);
  const [yuvajobs, setYuvajobs] = useState([]);
  const [yuvainternship, setYuvaInternships] = useState([]);

  useEffect(() => {
    getindustryjobs();
    getIndustryinternships();
    getYuvajobs();
    getYuvainternships();
  }, []);

  const getindustryjobs = () => {
    server
      .get("/job/bookmarks", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndjobs(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const getIndustryinternships = () => {
    server
      .get("/internship/bookmarks", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndinternships(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const getYuvainternships = () => {
    server
      .get("/internship/admbookmarks", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setYuvaInternships(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  const getYuvajobs = () => {
    server
      .get("/job/admbookmarks", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setYuvajobs(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  return (
    <>
      <div className="container">
        <div className="row">
          {indjobs?.map((item) => {
            return (
              <>
                <div className="job-container col-md-4 my-3">
                  <div className="jobs">
                    <div className="job p-2">
                      <div className="row">
                        <div className="col-md-8">
                          <h5 className="job-title">{item.position}</h5>
                          <p>{item.company_name}</p>
                        </div>
                        <div className="col-md-2 text-center">
                          <img
                            src={item.image}
                            className="bg-light rounded-3 img-fluid"
                            width={100}
                            alt=""
                          />
                        </div>
                      </div>

                      <p>
                        <span className="fw-bold"> Status : &nbsp;</span>
                        <span className="badge bg-warning text-dark p-2">
                          {item.status1}
                        </span>
                      </p>
                      <p>
                        <span className="fw-bold">Openings : &nbsp;</span>
                        <span className="">{item.noofposition}</span>
                      </p>
                      <table>
                        <tr>
                          <td>
                            <FaLocationDot className="fs-4 me-2 text-danger " />
                          </td>
                          <td>
                            <p className="my-2">{item.address}</p>
                          </td>
                        </tr>
                      </table>
                      <div className="details text-center">
                        <div className="row p-1">
                          <div className="col m-2 btn btn-outline-info text-dark ">
                            {item.job_mode} Mode
                          </div>

                          <div className="col m-2 btn btn-outline-info text-dark ">
                            {item.experience} yr
                          </div>
                        </div>
                        <NavLink
                          to={`/industryjobs/${item.id}`}
                          className="banner text-white ms-2 bg-light btn w-75 "
                        >
                          More Details
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
          {indinternships?.map((item) => {
            return (
              <>
                <div className="internship-container col-md-4 my-3">
                  <div className="internships">
                    <div className="internship p-2">
                      <div className="row">
                        <div className="col-md-8">
                          <h5 className="internship-title">{item.position}</h5>
                          <p>{item.company_name}</p>
                        </div>
                        <div className="col-md-2 text-center">
                          <img
                            src={item.image}
                            className="bg-light rounded-3 img-fluid"
                            width={100}
                            alt=""
                          />
                        </div>
                      </div>

                      <p>
                        <span className="fw-bold"> Status : &nbsp;</span>
                        <span className="badge bg-warning text-dark p-2">
                          {item.status1}
                        </span>
                      </p>
                      <p>
                        <span className="fw-bold">Openings : &nbsp;</span>
                        <span className="">{item.noofposition}</span>
                      </p>
                      <table>
                        <tr>
                          <td>
                            <FaLocationDot className="fs-4 me-2 text-danger " />
                          </td>
                          <td>
                            <p className="my-2">{item.address}</p>
                          </td>
                        </tr>
                      </table>
                      <div className="details text-center">
                        <div className="row p-1">
                          <div className="col m-2 btn btn-outline-info text-dark ">
                            {item.internship_mode} Mode
                          </div>

                          <div className="col m-2 btn btn-outline-info text-dark ">
                            {item.internship_period}
                          </div>
                        </div>
                        <NavLink
                          to={`/industryinternships/${item.id}`}
                          className="banner text-white ms-2 bg-light btn w-75 "
                        >
                          More Details
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
          {yuvajobs?.map((item) => {
            return (
              <>
                <div className="job-container col-md-4 my-3">
                  <div className="jobs">
                    <div className="job p-2">
                      <div className="row">
                        <div className="col-md-8">
                          <h5 className="job-title">{item.position}</h5>
                          <p>{item.company_name}</p>
                        </div>
                        <div className="col-md-2 text-center">
                          <img
                            src={item.image}
                            className="bg-light rounded-3 img-fluid"
                            width={100}
                            alt=""
                          />
                        </div>
                      </div>

                      <p>
                        <span className="fw-bold"> Status : &nbsp;</span>
                        <span className="badge bg-warning text-dark p-2">
                          {item.status}
                        </span>
                      </p>
                      <p>
                        <span className="fw-bold">Openings : &nbsp;</span>
                        <span className="">{item.noofposition}</span>
                      </p>
                      <table>
                        <tr>
                          <td>
                            <FaLocationDot className="fs-4 me-2 text-danger " />
                          </td>
                          <td>
                            <p className="my-2">{item.address}</p>
                          </td>
                        </tr>
                      </table>
                      <div className="details text-center">
                        <div className="row p-1">
                          <div className="col m-2 btn btn-outline-info text-dark ">
                            {item.job_mode} Mode
                          </div>

                          <div className="col m-2 btn btn-outline-info text-dark ">
                            {item.experience} yr
                          </div>
                        </div>
                        <NavLink
                          to={`/jobs/${item.id}`}
                          className="banner text-white ms-2 bg-light btn w-75 "
                        >
                          More Details
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
          {yuvainternship?.map((item) => {
            return (
              <>
                <div className="job-container col-md-4 my-3">
                  <div className="jobs">
                    <div className="job p-2">
                      <div className="row">
                        <div className="col-md-8">
                          <h5 className="job-title">{item.position}</h5>
                          <p>{item.company_name}</p>
                        </div>
                        <div className="col-md-2 text-center">
                          <img
                            src={item.image}
                            className="bg-light rounded-3 img-fluid"
                            width={100}
                            alt=""
                          />
                        </div>
                      </div>

                      <p>
                        <span className="fw-bold"> Status : &nbsp;</span>
                        <span className="badge bg-warning text-dark p-2">
                          {item.status}
                        </span>
                      </p>
                      <p>
                        <span className="fw-bold">Openings : &nbsp;</span>
                        <span className="">{item.noofposition}</span>
                      </p>
                      <table>
                        <tr>
                          <td>
                            <FaLocationDot className="fs-4 me-2 text-danger " />
                          </td>
                          <td>
                            <p className="my-2">{item.address}</p>
                          </td>
                        </tr>
                      </table>
                      <div className="details text-center">
                        <div className="row p-1">
                          <div className="col m-2 btn btn-outline-info text-dark ">
                            {item.internship_mode} Mode
                          </div>

                          <div className="col m-2 btn btn-outline-info text-dark ">
                            {item.internship_period}
                          </div>
                        </div>
                        <NavLink
                          to={`/internships/${item.id}`}
                          className="banner text-white ms-2 bg-light btn w-75 "
                        >
                          More Details
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Bookmark;
